import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "CategoryAdd"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.25 4.5L10.1925 5.5575L12.8775 8.25L10.1925 10.9425L11.25 12L15 8.25L11.25 4.5ZM12.75 18H21C21.8284 18 22.5 18.6716 22.5 19.5V22.5H21V19.5H12.75V22.5H11.25V19.5H3V22.5H1.5V19.5C1.5 18.6716 2.17157 18 3 18H11.25V15H6.75C5.92192 14.9992 5.25083 14.3281 5.25 13.5V3C5.25083 2.17192 5.92192 1.50083 6.75 1.5H17.25C18.0781 1.50083 18.7492 2.17192 18.75 3V13.5C18.7488 14.3279 18.0779 14.9988 17.25 15H12.75V18ZM17.25 3H6.75V13.5H17.2515L17.25 3Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/CategoryAdd.vue"]]);
